// extracted by mini-css-extract-plugin
export var checkbox = "Form-module--checkbox--5d6a0";
export var checkboxContainer = "Form-module--checkboxContainer--93e1e";
export var checkboxLabel = "Form-module--checkboxLabel--90992";
export var checkboxOptionContainer = "Form-module--checkboxOptionContainer--26199";
export var checkmark = "Form-module--checkmark--b514c";
export var error = "Form-module--error--b8332";
export var formContainer = "Form-module--formContainer--6e692";
export var formMessage = "Form-module--formMessage--f5399";
export var formMessageError = "Form-module--formMessageError--c7698";
export var formMessageSuccess = "Form-module--formMessageSuccess--d5267";
export var formScreen = "Form-module--formScreen--bb04c";
export var formSubmitted = "Form-module--formSubmitted--98f84";
export var formSubmitting = "Form-module--formSubmitting--52bdf";
export var helperText = "Form-module--helperText--175c7";
export var infoBlock = "Form-module--infoBlock--89b83";
export var input = "Form-module--input--34663";
export var inputContainer = "Form-module--inputContainer--61de7";
export var inputsContainer = "Form-module--inputsContainer--3add6";
export var label = "Form-module--label--089ad";
export var showThankYouScreenAsLabel = "Form-module--showThankYouScreenAsLabel--e6a9e";
export var singleCheckboxText = "Form-module--singleCheckboxText--dac40";
export var submitButton = "Form-module--submitButton--23c4b";
export var text = "Form-module--text--37042";
export var textContainer = "Form-module--textContainer--5cd22";
export var textInput = "Form-module--textInput--f3723";
export var thankYouIcon = "Form-module--thankYouIcon--bdb23";
export var thankYouScreenContainer = "Form-module--thankYouScreenContainer--9beca";
export var thankYouText = "Form-module--thankYouText--f4428";
export var thankYouTitle = "Form-module--thankYouTitle--80a3c";
export var title = "Form-module--title--3df7a";
export var visuallyHidden = "Form-module--visuallyHidden--9fa45";
export var withBackgroundColor = "Form-module--withBackgroundColor--0b7c4";
export var withSubmitButtonInsideInput = "Form-module--withSubmitButtonInsideInput--5804f";
export var withTextBlock = "Form-module--withTextBlock--f1acc";